<template>
 <div>
    <div class="container-collab d-flex w-full h-full">
      <div class="col-md-3  w-full h-full">

      <filterForm @partNumber="filterTableByPartNumber($event)"/>
      </div>
      <div class="col-md-9">
        <!-- ZC-46: `:newHeaderStatus` TEM que ser true. O slot `ButtonsAprova`, onde vive o
             botao RELATORIO, so e renderizado dentro de `v-if="newHeaderStatus"` (Tables.vue:19).
             Com `false` o botao existia no bundle e NUNCA aparecia na tela.
             ATENCAO: este comentario mora AQUI, FORA da tag. A primeira versao deste conserto
             colocou o comentario ENTRE os atributos da tag Tables, o que e HTML invalido -- o parser
             fechou a tag na abertura do comentario e os atributos restantes vazaram como TEXTO na tela. Quebrou a
             tela do Diversos no aceite, e minha checagem de tags balanceadas nao pegou porque so
             contava abre/fecha. -->
        <!-- ZC-46 / task 026: `:pagingLimitDefault="1000"`. O default do Tables.vue e 10
             (Tables.vue:242-244) e esta tela esconde o paginador (`:showPaging="false"`), entao o
             `pagingLimit` de 10 ia para a API e o colaborador via 10 lotes SEM nada indicando que
             faltavam os outros -- medido em producao: 518 de 923 pares funcionario/empresa (56%)
             tem mais de 10 lotes, pior caso 99. O AILTON 83545 do aceite tem 28 e o Rodrigo via
             10. Esconder o paginador nao desliga a paginacao; desliga so a UI de navegar.
             1000 cobre o pior caso da base (99) com folga larga. Se um dia passar de 1000, volta
             a truncar calado -- ai o conserto e paginador de verdade, nao numero maior. -->
        <Tables ref="detailsTab"
                  :columns="['Lote','Nome Usuário','Função' ,'Obra','Início Viagem','Fim Viagem','  Qtd. de despesas','Anexos','Total Gastos','Impresso']"
                  :showSearch="false"
                  :showPrint="false"
                  :showDownload="false"
                  :showFullscreen="false"
                  :newHeaderStatus="true"
                  :backPageLeft="false"
                  :showPaging="false"
                  :pagingLimitDefault="1000"
                  :showCheckInput="true"
                  v-on:check="marcarTodos"
                  v-on:Load="onLoad"
                  :key="0"
                >
                <template #return>
                    <div class="button-container" v-b-tooltip.hover title="Retornar">
                      <button type="button" v-on:click="$router.back()" class="btn btn-third btn-sm" ><i style="font-size:16px;padding-top:2px" class="fas fa-arrow-circle-left "></i></button>
                    </div>
                </template>
                <template #ButtonsAprova>
                  <div class="button-container" v-b-tooltip.hover>
                    <!-- `botao-relatorio-lotes` da seletor ESTAVEL pro teste: mirar por texto
                         pegava "Relatórios" do Sidebar, porque o match e por substring. -->
                    <button type="button"
                            class="btn btn-third btn-sm botao-relatorio-lotes"
                            :disabled="!!motivoTetoRelatorio"
                            style="white-space:nowrap"
                            :title="motivoTetoRelatorio || `Gerar um PDF com ${todosOsLotes ? anexosTotais : anexosSelecionados} anexos de ${todosOsLotes ? details.length : selecionados.length} lote(s)`"
                            @click="gerarRelatorioSelecionados">
                      <i style="font-size:14px;padding-right:4px" class="fa fa-file-pdf"></i>
                      RELATÓRIO ({{ todosOsLotes ? details.length : selecionados.length }})
                      <span style="opacity:.85">· {{ todosOsLotes ? anexosTotais : anexosSelecionados }}/{{ tetoAnexos }} anexos</span>
                    </button>
                  </div>
                </template>
                <template #download>
                  <div class="button-container-download" v-b-tooltip.hover title="Download" @click=gerarPdf>
                      <button type="button" class="button-back" ><i style="font-size:16px;padding-top:2px" class="fa fa-download "></i></button>
                    </div>
                </template>
                  <tr v-for="(detail,index) in details" :key="index" >
                    <!-- ZC-46: `input type=checkbox` nativo, e nao `b-form-checkbox`. O cabecalho
                         desta grid usa input nativo (Tables.vue:69) e o `b-form-checkbox` vem dentro
                         de um `.custom-control` com padding proprio -- era isso que deixava a caixa
                         do corpo deslocada da do cabecalho. -->
                    <TableColumn :IsCustom="true" :status="1">
                      <div class="celula-check" v-b-tooltip.hover :title="motivoLoteTravado(detail)">
                        <input type="checkbox"
                               :checked="todosOsLotes || selecionados.includes(detail.loteID)"
                               :disabled="!todosOsLotes && !podeMarcarLote(detail)"
                               @change="alternarLote(detail.loteID)">
                      </div>
                    </TableColumn>
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.lote"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.nome"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.funcao"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.obra"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.dataInicioViagem"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.dataFimViagem"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.totalDespesa"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <!-- ZC-46: `String(...)` de proposito. O TableColumn faz
                         `{{ (value) ? value : 'N/D' }}` (TableColumn.vue:5) e 0 e FALSY, entao
                         lote com ZERO comprovante saia escrito "N/D" -- escondendo exatamente a
                         informacao que o teto existe para dar. Visto no aceite nos lotes 10 e 18
                         do ADENILSON RIBEIRO ARAUJO. -->
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="String(detail.anexos || 0)"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="formatMoney(detail.valorTotalGastos)"
                      v-on:Edit="showModal(detail.loteID);
                                partStartDate = detail.dataInicioViagem;
                                partEndDate = detail.dataFimViagem ;
                                partNumber = detail.lote;
                                totalPartValue = detail.valorTotalGastos"
                    />
                    <!-- ZC-46: SINALIZA que o relatorio deste lote ja foi baixado nesta sessao, e
                         NAO impede baixar de novo -- o checkbox segue habilitado. Coluna propria no
                         fim da linha, a pedido do Rodrigo. -->
                    <TableColumn :IsCustom="true" :status="1">
                      <div class="celula-impresso">
                        <i v-if="foiBaixado(detail.loteID)"
                           class="fas fa-check-circle text-success lote-ja-baixado"
                           v-b-tooltip.hover title="Relatório deste lote já baixado nesta sessão"></i>
                      </div>
                    </TableColumn>
                  </tr>
        </Tables>
      </div>
    </div>
    <b-modal
      centered hide-footer
      ref="detailsModalRef"
      :no-close-on-backdrop="true"
      size="xl"
      >
      <details-modal
        :partId="partId"
        :partStartDate="partStartDate"
        :partEndDate="partEndDate"
        :partNumber ="partNumber"
      :collabId ="collabId"
        :totalPartValue="totalPartValue"
      />
    </b-modal>
    <reportPdf ref="reportPdf"></reportPdf>
 </div>
</template>

<script>
import CollaboratorTableTravelExpenseEmployeSeveral from './CollaboratorTableTravelExpenseEmployeSeveral.js'
export default CollaboratorTableTravelExpenseEmployeSeveral

</script>

<style scoped>
/* ZC-46: as duas colunas de icone centradas, e o cabecalho junto. O `th` do check
   (Tables.vue:69) nao tem alinhamento proprio, entao vem do `::v-deep` daqui. */
.celula-check,
.celula-impresso {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 16px;
}
.celula-check input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}
.celula-check input[type="checkbox"]:disabled {
  cursor: not-allowed;
}
::v-deep thead th:first-child,
::v-deep thead th:last-child {
  text-align: center;
}
/* marca de "ja baixado nesta sessao" */
.lote-ja-baixado {
  font-size: 14px;
}

.container-collab{
  justify-content: space-between;
}
.button-container{
  display: flex;
  align-items: center;
}
.button-container-download{
  display: flex;
  align-items: center;
  width: 3rem;
}
.button-back{
  width: 4rem;
  border-radius: 5px;
  background-color: #008148;
  color: #fff;
  border: 0;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/CollaboratorTableTravelExpenseEmployeSeveral/CollaboratorTableTravelExpenseEmployeSeveral.vue